import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import PageHeading from "../../../../../components/common/PageHeading";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../../components/common/RightBar";

import { Card, Col, Popover, Row } from "antd";
import { FaCheck, FaQuestionCircle } from "react-icons/fa";

import { bankCompletedTransfers } from "../../../../../data/accounting";

import "./BankTransfer.css";

const CompletedTransfersRightBar = [
  RightBarMethod(
    " REPORTS",
    "t1",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Bank Account Activity", "1", "", "", "/"),
      RightBarMethod("General Ledger", "2", "", "", "/"),
    ]
  ),
];

function BankTransfer() {
  const [BankTransfer, setBankTransfer] = useState({});
  const [len, setLen] = useState();
  const [auditLog, setAuditLog] = useState([]);
  const { id } = useParams();

  console.log(BankTransfer.auditLog);

  useEffect(() => {
    const bankTransfer = bankCompletedTransfers.find((item) => {
      return item.id === Number(id);
    });
    setLen(bankTransfer.transfersIncluded.length);
    setAuditLog(bankTransfer.auditLog);
    setBankTransfer(bankTransfer);
  }, []);

  return (
    <>
      <div className="bank-transfer">
        <PageHeading heading="Bank Transfer" />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Card title="Transfer Details">
              <Row className="transfer-details-container">
                <Col span={12} className="col-container">
                  <span className="silver-text">Status</span>
                  {BankTransfer.completed ? (
                    <span className="completed-span">completed</span>
                  ) : (
                    <span className="canceled-span">canceled</span>
                  )}
                </Col>
                <Col span={12} className="col-container">
                  <span className="silver-text">Date Created</span>
                  {BankTransfer.createdDate !== "" ? (
                    <span>{BankTransfer.createdDate}</span>
                  ) : (
                    <span>--</span>
                  )}
                </Col>
              </Row>
              <Row className="transfer-details-container">
                <Col span={12} className="col-container">
                  <span className="silver-text">Amount</span>
                  <span>${BankTransfer.amount}</span>
                </Col>
                <Col span={12} className="col-container">
                  <span className="silver-text">Date Created</span>
                  {BankTransfer.transferredDate !== "" ? (
                    <span>{BankTransfer.transferredDate}</span>
                  ) : (
                    <span>--</span>
                  )}
                </Col>
              </Row>
              <Row className="transfer-details-container">
                <Col span={12} className="col-container">
                  <span className="silver-text">Reference</span>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Transfer Summary">
              <div className="transfer-summury-container">
                <Row className="transfer-summury" gutter={[16, 0]}>
                  <Col className="amount-container">
                    <h4>Transferred From</h4>
                  </Col>
                  <Col className="amount-container">
                    <h4>Transferred To</h4>
                  </Col>
                </Row>
                <Row className="transfer-summury" gutter={[16, 0]}>
                  <Col className="amount-from-container">
                    <div>
                      <p>-${BankTransfer.amount}</p>
                      <h4>{BankTransfer.transferredFrom}</h4>
                    </div>
                    <FaCheck className="icon red" size={26} />
                  </Col>
                  <Col className="amount-to-container">
                    <div>
                      <p>+${BankTransfer.amount}</p>
                      <h4>{BankTransfer.transferredTo}</h4>
                    </div>
                    <FaCheck className="icon green" size={26} />
                  </Col>
                </Row>
              </div>
              {len >= 1 ? (
                <div className="transfers-included">
                  <Row gutter={[0, 16]}>
                    <Col span={24}>
                      <span className="transfer-text">Transfers Included</span>
                    </Col>
                    <Col span={24}>
                      {BankTransfer.transfersIncluded.map((item, index) => {
                        return (
                          <Row key={index} className="transfers-container">
                            <Col span={4}>
                              <span>{item.amount}</span>
                            </Col>
                            <Col span={10}>
                              <span>{item.transfer}</span>
                            </Col>
                            <Col span={6}>
                              <span>Move Out</span>
                              <span>{item.moveOut}</span>
                            </Col>
                            <Col span={4}>
                              {item.completed ? (
                                <span className="completed-span">
                                  Completed
                                </span>
                              ) : (
                                <span className="canceled-span">Canceled</span>
                              )}
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
              ) : null}
            </Card>
          </Col>
          <Col span={24}>
            <Card
              title={
                <div className="title">
                  <span className="text">Non-cash Journal Entries</span>
                  <Popover content="Non-Cash journal entry will be post on original transfer date">
                    <FaQuestionCircle size={14} className="icon" />
                  </Popover>
                </div>
              }
            >
              <div className="journal-entries">
                <div className="journal-entries-container">
                  <Row className="header-row">
                    <Col span={8} className="header-col">
                      <span>Account</span>
                    </Col>
                    <Col span={8} className="header-col">
                      <span>Description</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Debit</span>
                    </Col>
                    <Col span={4} className="header-col">
                      <span>Credit</span>
                    </Col>
                  </Row>
                  <Row className="data-row">
                    <Col className="data-col">
                      <span>There are no non-cash journal entries</span>
                    </Col>
                  </Row>
                </div>
                <Row>
                  {" "}
                  <Col>
                    <span className="onclick-text">
                      Add or Edit Non-Cash Journal Entry
                    </span>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card title="Audit Log">
              {auditLog.map((item, index) => {
                return (
                  <div className="auditlog-main-container" key={index}>
                    {item.recieverTitle !== "" ? (
                      <Row className="auditlog-container">
                        <Col span={4}>
                          <span>{item.date}</span>
                        </Col>
                        <Col span={8}>
                          <strong>
                            Completed Bank Transfer of ${item.TransferAmount}
                          </strong>
                        </Col>
                        <Col span={1}>
                          <span> -- </span>
                        </Col>
                        <Col span={11}>
                          <span className="onclick-text">
                            {item.recieverTitle}
                          </span>
                        </Col>
                      </Row>
                    ) : null}
                    {item.incompleteRecieverTitle !== "" ? (
                      <Row className="auditlog-container">
                        <Col span={4}>
                          <span>{item.incompleteTransferDate}</span>
                        </Col>
                        <Col span={8}>
                          <strong>
                            InCompleted Bank Transfer of $
                            {item.incompleteTransferAmount}
                          </strong>
                        </Col>
                        <Col span={1}>
                          <span>--</span>
                        </Col>
                        <Col span={11}>
                          <span className="onclick-text">
                            {item.incompleteRecieverTitle}
                          </span>
                        </Col>
                      </Row>
                    ) : null}
                    {item.canceledRecieverTitle !== "" ? (
                      <Row className="auditlog-container">
                        <Col span={4}>
                          <span>{item.canceledTransferDate}</span>
                        </Col>
                        <Col span={8}>
                          <strong>
                            canceled Bank Transfer of $
                            {item.canceledTransferAmount}
                          </strong>
                        </Col>
                        <Col span={1}>
                          <span>--</span>
                        </Col>
                        <Col span={11}>
                          <span className="onclick-text">
                            {item.canceledRecieverTitle}
                          </span>
                        </Col>
                      </Row>
                    ) : null}
                  </div>
                );
              })}
            </Card>
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={CompletedTransfersRightBar} />
      </div>
    </>
  );
}

export default BankTransfer;
